import { inject } from '@angular/core';
import { ActivatedRoute, type Event, NavigationEnd, Router } from '@angular/router';
import { filter, map, type Observable, startWith } from 'rxjs';

export const injectTitleKey = (defaultKey: string): Observable<string> => {
    const router: Router = inject(Router);
    const route: ActivatedRoute = inject(ActivatedRoute);

    return router.events.pipe(
        filter((e: Event) => e instanceof NavigationEnd),
        startWith(null),
        map(() => route.firstChild?.snapshot?.data['titleKey'] ?? defaultKey)
    );
};
